import React, { useEffect, useState } from 'react'
import { useSelector } from "react-redux";
import { Link } from 'react-router-dom'
import '../../../../styles/smart_wizard_all.css'
import { currencyConvertor, showAlert } from '../../../../Utils/Utility';
import BilledHeader from './BilledHeader'
import { useHistory, useLocation } from 'react-router';
import '../../../../styles/paymentdetails.css'
import { toast } from 'react-toastify';
import { injectIntl } from 'react-intl';

function PaymentDetails({ intl, ...props }) {
    const id = props.match.params.id;
    let totalfeeamount = 0;
    const loads = useSelector(state => state.billed.billedPo.loads);
    const load = loads.find(load => load.load_id === id)
    let unload_bill_amount = load.unloading_bill_amount;
    let total_bill_amount = load.total_bill_amount;
    let tin = load.tax_id
    let total_paid = load.total_paid;
    const [isDisabled, setDisabled] = useState(true);
    const [amount, setAmount] = useState(total_bill_amount);
    const [remainingAmount, setRemainingAmount] = useState(0);
    const [selection, Setselection] = useState("Full Payment")
    const [togglebutton, setTogglebutton] = useState(false)
    const location = useLocation();
    const [totalremainingAmount, setTotalremainingAmount] = useState(0);
    const history = useHistory();
    const { formatMessage } = intl;


    useEffect(() => {
        if (location?.state?.totalremainingAmount) {
            setTotalremainingAmount(location?.state?.totalremainingAmount);
        }
        else {
            if (total_paid > 0) {
                setTotalremainingAmount(+total_bill_amount - +total_paid);
            }
        }
    }, []);

    const handleChange = (e) => {


        if (e.target.value === "Full Payment") {
            Setselection("Full Payment");
            setDisabled(true);
            setTogglebutton(false)
            setRemainingAmount(0);
            document.getElementById("Partial Amount").value = ""
            setAmount(total_bill_amount);
        }
        else if (e.target.value === "Partial Payment") {
            Setselection("Partial Payment");
            setDisabled(false);
            setTogglebutton(true)
        }
        else {
            Setselection("Partial Payment")
            setDisabled(false);
            let partialAmount = e.target.value;
            partialAmount = +partialAmount > +total_bill_amount ? total_bill_amount : partialAmount;

            const finalAmount = total_bill_amount - partialAmount;
            e.target.value ? setTogglebutton(false) : setTogglebutton(true)

            setRemainingAmount(currencyConvertor(finalAmount));
            setAmount(partialAmount);
        }


    }

    const handleSubmit = () => {
        if (amount == 0) {
            showAlert(toast.TYPE.WARNING, "Please enter valid amount");
        }
        else {
            history.push({
                pathname: `/selectpayment/${id}`,
                state: { amount, selection, remainingAmount, totalremainingAmount, total_bill_amount, tin } // your data array of objects
            });
            return null;
        }


    }

    return (
        <div className="content-page">
            <div className="content">
                <div className="contest_input_block">
                    <div className="contest_preview">
                        <BilledHeader path={`/billedDetails/${id}`} />
                        <div className="container_block" style={{ padding: '40px' }}>
                            <div id="smartwizard" className="sw sw-theme-dots sw-justified">
                                <div id="step-2" className="tab-pane" role="tabpanel" aria-labelledby="step-2">
                                    <section>
                                        <h4 className="mb-3 txtwhite">{formatMessage({ id: "app.payment_details" })}</h4>
                                        <p>{formatMessage({ id: "app.total_payment_amount" })}
                                            {totalremainingAmount > 0 ?
                                                <strong className="remaining_amt ml-1">
                                                    ${currencyConvertor(totalremainingAmount)}
                                                </strong>
                                                :
                                                <strong className="remaining_amt ml-1">
                                                   ${currencyConvertor(total_bill_amount)}
                                                </strong>
                                            }
                                        </p>

                                        <div className="row">
                                            <div className="col-4">
                                                <div className="checkbox-circle">

                                                    <label className="active">
                                                        <input type="radio" name="PaymentRadio"
                                                            value="Full Payment" onChange={handleChange} defaultChecked />{formatMessage({ id: "app.full_payment" })}
                                                        <span className="checkmark"></span>
                                                    </label>
                                                    {totalremainingAmount <= 0 &&
                                                        <>
                                                            <label>
                                                                <input type="radio" name="PaymentRadio"
                                                                    value="Partial Payment" onChange={handleChange} />{formatMessage({ id: "app.partial_payment" })}
                                                                <span className="checkmark"></span>
                                                            </label>

                                                            <div className="col-12 ml-2 col-sm">
                                                                <input type="number" className="form-control mb-2"
                                                                    style={{ opacity: '1 !important' }} id="Partial Amount" disabled={isDisabled} onChange={handleChange} pattern="[0-9]+" />
                                                                <span>{formatMessage({ id: "app.remaining_amount" })} <strong className="remaining_amt">${currencyConvertor(remainingAmount)}</strong></span>
                                                            </div>
                                                        </>
                                                    }
                                                </div>

                                            </div>
                                        </div>
                                        <div className="toolbar toolbar-bottom" role="toolbar" style={{ textAlign: "right" }}>

                                            <button type="button" disabled={togglebutton} className="btn sw-btn-next btn-chartreuse float-right" onClick={handleSubmit}>{formatMessage({ id: "app.continue" })}</button>

                                        </div>
                                    </section>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default injectIntl(PaymentDetails);

